// extracted by mini-css-extract-plugin
export default {"content__wrapper":"Content_content__wrapper__JMSQS","content":"Content_content__36+-n","content__image":"Content_content__image__Bl18T"};